var ProductFilterAndSearchCache = {
    previousVendor: ''
};

// // Override Settings
// var bcSfFilterSettings = {
//     general: {
//         limit: 16
//         /* Optional */
//         // loadProductFirst: true,
//     }
// };

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'product-grid-item--sold-out',
    'saleClass': 'product-grid-item--on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': document.querySelectorAll('[data-template-for="product-grid-item-filter"]')[0].innerHTML,

    // Pagination Template
    'previousActiveHtml': '<li class="prev"><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="prev disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li class="next"><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="next disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span>{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li class="dots"><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

    'searchResultHeaderHtml': '<h1>' + bcSfFilterConfig.label.search_result_header + '</h1>',
    'searchResultNumberHtml': '<div>' + bcSfFilterConfig.label.search_result_number + '</div>',
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + ':</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = false; // Check a product is on sale
    // if (data.tags.indexOf('sale') > -1 || data.tags.indexOf('SALE') > -1 || data.tags.indexOf('outlet') > -1 || data.tags.indexOf('OUTLET') > -1) {

    let compare_at_price = data.compare_at_price_max;
    let compare_at_price_metafield = data.metafields?.find(metafield => metafield.key === 'compare_at_price');
    if (compare_at_price_metafield) {
        compare_at_price = compare_at_price_metafield.value * 100;
    }
    onSale = compare_at_price > data.price_max;
    // }
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var itemBadge = '';
    var itemNote;
    var itemStitching = '';
    var doNotCropSetting = '';
    var showOnCollection = false;
    const settingsRawJson = document.querySelector("#swatches-settings");
    let stitchingSettings = {};
    if (settingsRawJson) {
        stitchingSettings = JSON.parse(settingsRawJson.innerHTML);
        if (stitchingSettings.doNotCrop === true) {
            doNotCropSetting = `class="swatch-not-cropped"`;
        }
        if (stitchingSettings.showOnCollection === true) {
            showOnCollection = true;
        }
    }
    var itemSuitSeparate = false;
    var itemHire = false;

    var tags = data.tags;
    for (var i = tags.length - 1; i >= 0; i--) {

        var tag = tags[i].toLowerCase();
        let badgeLabel = '';
        let badgeBg = '';
        let badgeBorder = '';
        let badgeColor = '';

        if (tag.indexOf('badge-label') > -1) {
            if (tag.indexOf('badge-bg') > -1 || tag.indexOf('badge-border') > -1 || tag.indexOf('badge-color') > -1) {
                let badgeValues = tag.split(';');
                for (let badgeValue of badgeValues) {
                    if (badgeValue.indexOf('badge-label') > -1) {
                        badgeLabel = badgeValue.replace('badge-label:','').trim();
                    } else if (badgeValue.indexOf('badge-bg') > -1) {
                        badgeBg = 'background-color:' + badgeValue.replace('badge-bg:','').trim() + ';';
                    } else if (badgeValue.indexOf('badge-border') > -1) {
                        badgeBorder = 'border-color:' + badgeValue.replace('badge-border:','').trim() + ';';
                    } else if (badgeValue.indexOf('badge-color') > -1) {
                        badgeColor = 'color:' + badgeValue.replace('badge-color:','').trim() + ';';
                    }
                }
                itemBadge += '<div class="product-grid-item__badge" style="' + badgeBg + badgeBorder + badgeColor + '">' + badgeLabel + '</div><br>';
            } else {
                itemBadge += '<div class="product-grid-item__badge">' + tag.replace('badge-label','').trim() + '</div><br>';
            }
            continue;
        }
        
        if (Object.keys(stitchingSettings).length > 0 && stitchingSettings.groupTag !== '' && tag.indexOf(stitchingSettings.groupTag) > -1) {
            itemStitching = tag.trim();
            continue;
        }

        if (tag.indexOf('note:') > -1) {
            itemNote = tag.replace('note:','').trim();
            continue;
        }

        if (tag.indexOf('waistcoat avail') > -1) {
            itemNote = 'Waistcoat available';
            continue;
        }

        if (tag == 'hire') {
            itemHire = true;
            continue;
        }
    }

    if (data.product_type == "Created SUIT SEPARATES") {
        itemSuitSeparate = true;
    }

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

// Determine device type
var isMobile = window.innerWidth <= 768;  // Assuming a threshold of 768px for mobile devices

// Set target image width based on device type
document.addEventListener('DOMContentLoaded', function() {

// Update image sources based on device type
var images = document.querySelectorAll('img[data-mobile-src], img[data-desktop-src]');
images.forEach(function(img) {
    if (isMobile) {
        img.setAttribute('data-src', img.getAttribute('data-mobile-src'));
    } else {
        img.setAttribute('data-src', img.getAttribute('data-desktop-src'));
    }
});

});

var imageTargetWidth = isMobile ? 300 : 500;

    var imageTargetHeight = Math.ceil(images[0].height * (imageTargetWidth / images[0].width));

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl.replace('_large', `_${imageTargetWidth}x`));
    itemHtml = itemHtml.replace(/{{itemThumbWidth}}/g, imageTargetWidth);
    itemHtml = itemHtml.replace(/{{itemThumbHeight}}/g, imageTargetHeight);


    // Add Placeholder
    var itemThumbPlaceholder = images.length > 0 ? Math.round(1 / (images[0].width / images[0].height) * 100.0, 3) : 100;
    itemHtml = itemHtml.replace(/{{itemThumbPlaceholder}}/g, itemThumbPlaceholder);

    // Add hover Thumbnail
    if (typeof images[1] != 'undefined' && typeof images[1]['src'] != 'undefined') {
        var itemHoverThumbUrl = images.length > 0 ? this.optimizeImage(images[1]['src']) : bcSfFilterConfig.general.no_image_url;
        var itemHoverTargetHeight = Math.ceil(images[1].height * (imageTargetWidth / images[1].width));
        itemHtml = itemHtml.replace(/{{itemHoverThumbUrl}}/g, itemHoverThumbUrl.replace('_large', `_${imageTargetWidth}x`));
        itemHtml = itemHtml.replace(/{{itemHoverThumbWidth}}/g, imageTargetWidth);
        itemHtml = itemHtml.replace(/{{itemHoverThumbHeight}}/g, itemHoverTargetHeight);
        itemHtml = itemHtml.replace('hover-disabled', '');
    } else {
        itemHtml = itemHtml.replace(/{{itemHoverThumbUrl}}/g, bcSfFilterConfig.general.no_image_url);
    }


    // Add Hover Image
    var itemThumbHoverUrl = images.length > 1 ? this.optimizeImage(images[1]['src']) : bcSfFilterConfig.general.no_image_url;
    if (itemThumbHoverUrl.indexOf('no-image') !== -1) {
        itemHtml = itemHtml.replace(/{{itemThumbHoverPlaceholder}}/g, '');
    } else {
        itemHtml = itemHtml.replace(/{{itemThumbHoverPlaceholder}}/g, '<div class="product-grid-item--hover-image hidden-xs hidden-sm">' +
                                                                        '<img loading="lazy" class="lazyload" data-sizes="auto" data-src="{{itemThumbHoverUrl}}" alt="{{itemTitle}}" />' +
                                                                      '</div>');
        itemHtml = itemHtml.replace(/{{itemThumbHoverUrl}}/g, itemThumbHoverUrl);
    }

    // Add Price
    var itemPriceHtml = '';
    // if (data.title != '' && !itemSuitSeparate)  {
    let hidePrice = false;
    if (data.vendor === 'R.M. Williams' || data.tags.indexOf('R. M. Williams') > -1  || data.tags.indexOf('R M Williams') > -1 || data.title.indexOf('R.M. Williams') > -1) {
        hidePrice = true
    }
    
    if (data.title != '' && hidePrice === false )  {
        itemPriceHtml += '<div data-price-wrapper class="product__price">';

        if (priceVaries) {
            itemPriceHtml += '<span data-product-price class="money">' + (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</span>';
        } else {
            itemPriceHtml += '<span data-product-price class="money">' + this.formatMoney(data.price_min) + '</span>';
        }

        if (onSale) {
            itemPriceHtml += '<s data-compare-price class="money">' + this.formatMoney(compare_at_price) + '</s> ';
        }

        if (soldOut) {
            itemPriceHtml += '<span class="product-grid-item__sold-out-message">Sold out</span>';
        }

        itemPriceHtml += '</div>';

        itemPriceHtml.replace('.00','');
    }
    
    itemHtml = itemHtml.replace(/{{ itemPrice }}/g, itemPriceHtml);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    var vendorBadgeHtml = '';

    itemHtml = itemHtml.replace(/{{itemVendorBadge}}/g, vendorBadgeHtml)

    itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadge);

    var wishlistBadgeHtml = '';
    if (!itemHire && !itemSuitSeparate) {
        wishlistBadgeHtml = theme.utils.getTemplate('product-grid-item-wishlist-badge');
    }
    itemHtml = itemHtml.replace(/{{itemWishlistBadge}}/g, wishlistBadgeHtml);

  	var noteHtml = '';
    if (itemNote) {
        noteHtml = '<div class="product-grid-item__note">' + itemNote + '</div>';
    } else {
        noteHtml = '';
    }
    itemHtml = itemHtml.replace(/{{itemNote}}/g, noteHtml);
  	var stitchingHtml = '';
    if (itemStitching !== '' && showOnCollection === true) {
        stitchingHtml = `<div class="product-grid-item__stitching group-by-product-tag">
            <product-stitching ${doNotCropSetting}
                               data-product-id="${data.id}"
                               data-product-handle="${data.handle}"
                               data-product-name="${data.title}"
                               data-group-tag="${itemStitching}">
                <ul class="product-stitching__color-list"></ul>
            </product-stitching>
        </div>`;
    } else {
        stitchingHtml = '';
    }
    itemHtml = itemHtml.replace(/{{itemStitching}}/g, stitchingHtml);
    itemHtml = itemHtml.replace(/{{itemVariantId}}/g, firstVariant.id);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);

    itemHtml = itemHtml.replace(/href=\"\"/g, 'href="/products/' + data.handle +'"');
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);

    itemHtml = itemHtml.replace(/{{data}}/g, JSON.stringify(data));

    if(window.bundleTitle) {
        itemHtml = itemHtml.replace(/{{ bundle_title }}/g, window.bundleTitle)
    } else {
        itemHtml = itemHtml.replace(/collection__header-tag/g, 'hidden')
    }

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (document.body.classList.contains('template-article') && !this.queryParams.q) {
        return false;
    }
    
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml).replace('_=pf&', '');

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage])).replace('_=pf&', '');
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

function buildSearchResultHeader(term) {
    if (term === null) return '';
    var html = bcSfFilterTemplate.searchResultHeaderHtml;

    html = html.replace(/{{ terms }}/g, term);
    
    return html;
}

function buildSearchResultNumber(term, total_product) {
    if (term === null) return '';
    var html = bcSfFilterTemplate.searchResultNumberHtml;

    html = html.replace(/{{ terms }}/g, term);
    html = html.replace(/{{ count }}/g, total_product);
    
    return html;
}

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {

    $('[data-search-result-header]').html(buildSearchResultHeader(bcsffilter.getSearchTerm()))
    $('[data-search-result-number]').html(buildSearchResultNumber(bcsffilter.getSearchTerm(), data.total_product))

    if(data.total_product == 0) {
        $('#search-no-result').show()
    }

    if (!data) {
        return;
    }

    theme.ProductFilterAndSearch.buildCollectionpage(data, eventType);

    theme.CurrencySelectors.init();

    // Remove dashes from filter options
    var $optionLabels = $('.bc-sf-filter-option-label');
    $.each($optionLabels, function(index, elem) {
        $elem = $(elem);
        $value = $('.bc-sf-filter-option-value', $elem);
        var currentValue = $value.html();

        if ($elem.data().parentLabel.indexOf('length') == 0 || $elem.data().parentLabel.indexOf('Length') == 0) {
            switch (currentValue) {
                case 'S':
                    $value.html('Short');
                    break;
                case 'R':
                    $value.html('Regular');
                    break;
                case 'T':
                    $value.html('Tall');
                    break;
            }
        } else {
            $value.html(currentValue.replace('-', ' '));
        }
    });



    // for (var i = $optionsValues.length - 1; i >= 0; i--) {
    //     var $el = $($optionsValues[i]);
    //     var val = $el.html();
    //     $el.html(val.replace('-', ' '));
    // }
};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */